import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdEdit, MdList, MdPersonAdd, MdTableView } from 'react-icons/md';
import { captialise_first_letter, tidy_date, tidy_date_raw, tidy_time_difference } from '../../utils/helper';
import Table from '../../components/app-components/Table';
import { fetch_all_users_admin } from '../../api/usersAPI'
import DataTable from '../../components/ui/DataTable';
import Button from '../../components/ui/Button';

export default function MembersPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchPlatformUsers()
  }, [])

  const fetchPlatformUsers = async () => {
    setLoading(true)
    const data = await fetch_all_users_admin()
    if (data?.status === 200) {
      setUsers(data.data)
    }
    setLoading(false)
  }


  let table_columns = [
    {
      header: "Name",
      accessor: "first_name",
      modifier: (value, row) => `${row?.first_name} ${row?.last_name}`
    },
    {
      header: "Email",
      accessor: "email",
    },
    {
      header: "Service",
      accessor: "service_type.name",
      modifier: (value, row) => `${value || "N/A"}`
    },
    {
      header: "Joined On",
      accessor: "createdAt",
      modifier: (value, row) => `${tidy_date(value)}`
    },
    {
      header: "Last Login",
      accessor: "last_login",
      modifier: (value, row) => `${tidy_time_difference(value)}`
    },
    {
      header: "Role",
      accessor: "role_ui",
      modifier: (value, row) => `${captialise_first_letter(value)}`
    },

  ]

  return (
    <AdminLayout
      navSelected={"Users"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>User Management</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/users/details?user_id=new")
            }}
          >
            <MdAdd size={16} />
            New User
          </button>
        </>
      }
    >

      {/* <div className="column items-center justify-between w-100 mb-4">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
        <div className="flex flex-col items-end w-full p-2">
          <div className="flex flex-row items-center bg-white rounded-md">
            <button className={`${dataView === "list" ? "bg-[var(--primary)]" : ""} rounded-md p-2`}>
              <MdList size={30} onClick={() => setDataView("list")} className={`${dataView === "list" ? "fill-white" : "fill-[var(--primary)]"} rounded-md p-2 text-sm`} />
            </button>
            <button className={`${dataView === "table" ? "bg-[var(--primary)]" : ""} rounded-md p-2`}>
              <MdTableView size={30} onClick={() => setDataView("table")} className={`${dataView === "table" ? "fill-white" : "fill-[var(--primary)]"} rounded-md p-2 text-sm`} />
            </button>
          </div>
        </div>
      </div> */}
      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <>
          {/* {dataView === "list" && <div className="w-100">
            {users.map((user, index) => {
              if (!JSON.stringify(user).toLowerCase().includes(query.toLowerCase())) return null
              return (
                <div
                  key={index}
                  className="flex-row items-center flex justify-between w-100 card mt-10"
                >
                  <div className="">
                    <h3>{user.first_name} {user.last_name}</h3>
                    <h3 className='card-subtitle'>{user?.service_type?.name}</h3>
                  </div>
                  <button
                    className="button"
                    onClick={() => {
                      navigate("/admin/users/details?user_id=" + user.id)
                    }}
                  >
                    View
                  </button>
                </div>
              )
            })}
          </div>}
          {dataView === "table" && <Table
            columns={table_columns}
            data={users?.map((user) => {
              if (query && !JSON.stringify(user).toLowerCase().includes(query.toLowerCase())) return {}
              return user
            })?.filter((user) => Object.keys(user).length > 0)}
            actions={(row) => {
              return (
                <>
                  <div className="flex flex-row items-center gap-2">
                    <button className="text-xs hover:underline" onClick={() => {
                      navigate("/admin/users/details?user_id=" + row.id, { replace: false })
                    }}>View</button>
                  </div>
                </>
              )
            }}
          />} */}

          <DataTable
            columns={table_columns}
            data={users}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" icon={MdEdit} onClick={() => navigate(`/admin/users/details?user_id=${row.id}`)}>
                    Edit
                  </Button>
                </div>
              )
            }}
          />
        </>
      )
      }
    </AdminLayout >
  )
}
